import React from "react";
import { Column, Row, Sheet, Text } from "@amzn/meridian";
import { InspectionResult } from "src/services/inspectionService";
import "./ComplianceDetailSheet.scss";
import ThemedTag from "./ThemedTag";

interface ComplianceDetailSheetProps {
    open: boolean;
    onClose: () => void;
    result: InspectionResult | null;
    presignedUrlMap: Record<string, string>;
}

const ComplianceDetailSheet: React.FC<ComplianceDetailSheetProps> = ({
    open,
    onClose,
    result,
    presignedUrlMap,
}) => {
    if (!result) return null;

    const evidenceUrl = result.evidence.length > 0
        ? presignedUrlMap[result.evidence[0].uri]
        : null;

    return (
        <Sheet type="overlay" side="bottom" open={open} onClose={onClose} className="compliance-detail-sheet">
            <Column spacing="400">
                <Text type="h300">Compliance Details</Text>
                <Row alignmentHorizontal="justify" alignmentVertical="top">
                    <Column spacing="400">
                        {result.objectId !== null && <Column spacing="100">
                            <Text type="b100" color="secondary">
                                Object ID:
                            </Text>
                            <Text type="b200" color="primary">
                                {result.objectId}
                            </Text>
                        </Column>}
                        <Column spacing="100">
                            <Text type="b100" color="secondary">Answer</Text>
                            <Text type="b200" color="primary">{result.confirmedResult}</Text>
                        </Column>
                    </Column>
                    <ThemedTag text={result.isCompliant ? "Compliant" : "Non Compliant"}
                        type={result.isCompliant ? "success" : "error"} />
                </Row>

                {result.aiReasoning && result.aiReasoning !== "" && <Column spacing="100">
                    <Text type="b100" color="secondary">Reason</Text>
                    <Text type="b200" color="primary">{result.aiReasoning}</Text>
                </Column>}

                {evidenceUrl && (
                    <Column spacing="100">
                        <Text type="b100" color="secondary">Evidence</Text>
                        <img
                            src={evidenceUrl}
                            alt="Evidence"
                            className="compliance-detail-sheet__image"
                        />
                    </Column>
                )}
            </Column>

        </Sheet>
    );
};

export default ComplianceDetailSheet;
